const FourthStep = () => {
    return (
        <>
            <p>Configuracion de la cuenta de BarllenoGo</p>
        </>
    )
}

export default FourthStep